import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';
import { Seo, seoConfig } from '../components/Seo';
import { getArticleBySlug } from '../data/articles';
import { DONATE_URL } from '../utils/donate';
export function ArticlePage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const article = getArticleBySlug(slug);
  if (!article) {
    return <Navigate to="/news" replace data-id="element-261" data-mp="ipwf5ywg63yu" />;
  }
  const articlePath = `/news/${article.slug}`;
  const articleUrl = `${seoConfig.siteUrl}${articlePath}`;
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-262" data-mp="4wewshfhyxae">
      <Seo title={article.title} description={article.excerpt} path={articlePath} type="article" image={article.image} schema={{
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      headline: article.title,
      description: article.excerpt,
      datePublished: article.date,
      dateModified: article.date,
      image: [article.image],
      mainEntityOfPage: articleUrl,
      author: {
        '@type': 'Organization',
        name: 'AZ City PAC',
        url: seoConfig.siteUrl
      },
      publisher: {
        '@type': 'Organization',
        name: 'AZ City PAC',
        url: seoConfig.siteUrl
      },
      articleSection: article.category,
      keywords: 'Arizona local voices, local decision-making, municipal leadership, Arizona cities and towns, growth and land use, infrastructure, safe neighborhoods, local economies'
    }} data-id="element-263" data-mp="9y4ay5y0nr2p" />
      <Navbar data-id="element-264" data-mp="1y6rjnx0favjd" />
      <main className="flex-grow pt-24" data-id="element-265" data-mp="1y681qgarw75c">
        <article data-id="element-266" data-mp="1ahoyif6kykk4">
          <header className="bg-pac-navy text-white" data-id="element-267" data-mp="1ah5lncvsemcy">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-12 md:pt-20 md:pb-16" data-id="element-268" data-mp="16h4xh0ivywsp">
              <Link to="/news" className="inline-flex items-center gap-2 text-pac-gold font-bold hover:text-white transition-colors mb-8 focus:outline-none focus:ring-2 focus:ring-pac-gold rounded" data-id="element-269" data-mp="35lwlx7wvs5mu">
                <ArrowLeft className="h-4 w-4" data-id="element-270" data-mp="3fbydwascu871" />
                Back to News
              </Link>
              <p className="text-pac-gold font-bold uppercase tracking-[0.18em] text-sm mb-4" data-id="element-271" data-mp="3k9zvsse1o1gx">
                {article.category} <span className="text-slate-400 mx-1" data-id="element-272" data-mp="2molsi3xxk6fb">·</span> {article.date}
              </p>
              <h1 className="font-serif text-4xl md:text-6xl font-bold leading-tight max-w-4xl" data-id="element-273" data-mp="2rm427wjrupod">
                {article.title}
              </h1>
            </div>
          </header>

          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-274" data-mp="31ktbj0xlr1t0">
            <img src={article.image} alt="" className="w-full h-64 md:h-[480px] object-cover rounded-b-xl shadow-lg" data-id="element-275" data-mp="bv950i5aume7" />

            <div className="max-w-3xl mx-auto py-14 md:py-20" data-id="element-276" data-mp="21bv7rd6w61bb">
              <p className="text-xl md:text-2xl leading-relaxed text-pac-navy font-serif mb-10" data-id="element-277" data-mp="21bbre0ww3kze">
                {article.excerpt}
              </p>
              <div className="space-y-7 text-lg leading-relaxed text-slate-700" data-id="element-278" data-mp="1rls6yqtj3j2f">
                {article.content.map(paragraph => <p key={paragraph} data-id="element-279" data-mp="1mm5tcg9sg0t3">{paragraph}</p>)}
              </div>

              <div className="mt-14 p-8 bg-pac-sand border-l-4 border-pac-gold" data-id="element-280" data-mp="1hox5q05vf4kg">
                <p className="text-pac-navy font-serif text-2xl font-bold mb-3" data-id="element-281" data-mp="1dm0wv164umtp">
                  Help strengthen Arizona&apos;s local voice.
                </p>
                <p className="text-slate-700 mb-6" data-id="element-282" data-mp="18p0oukpq39zy">
                  Your support helps AZ City PAC advance practical policies for strong cities, safe neighborhoods, and resilient communities.
                </p>
                <a href={DONATE_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-pac-red hover:bg-red-800 text-white px-6 py-3 rounded font-bold uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2" data-id="element-283" data-mp="2y244qqsfuyxh">
                  Contribute Now <ArrowRight className="h-4 w-4" data-id="element-284" data-mp="1qp3hm1w1nqfx" />
                </a>
              </div>

              <Link to="/news" className="inline-flex items-center gap-2 text-pac-blue font-bold hover:text-pac-navy transition-colors mt-12 focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 rounded" data-id="element-285" data-mp="1c0yxcthcf6v1">
                <ArrowLeft className="h-4 w-4" data-id="element-286" data-mp="12xxrmtwe3hrw" />
                See all updates
              </Link>
            </div>
          </div>
        </article>
      </main>
      <Footer data-id="element-287" data-mp="t2w2hy246fpb" />
    </div>;
}